export const Z_INDEX = {
    SECTION_HEADER: 1,
    GRID_HEADER: 2,
};
//# sourceMappingURL=consts.js.map